import React from 'react'
import {Popup} from 'react-leaflet'

import Icon from './Icon'
import Price from './Price'
import EstateDescription from './EstateDescription'

{/*
const EstatePopup = ({map, coordinates, address, onClose})=> {
    return <Popup map={map} position={coordinates} closeOnClick={false} closeButton={false}>
      <div>
        <div className="estate-popup-close-button pull-right" onClick={onClose}>
          <Icon name="times"/>
        </div>
        {address || null}
      </div>
    </Popup>
};

EstatePopup.propTypes = {
  map: React.PropTypes.object.isRequired,
  coordinates: React.PropTypes.shape({
    lat: React.PropTypes.number.isRequired,
    lng: React.PropTypes.number.isRequired, 
  }).isRequired,
  address: React.PropTypes.string,
  onClose: React.PropTypes.func.isRequired,
}
*/}

const EstatePopup = ({estate})=> {
    {/*
    return <div style={estateDescriptionContainer}>
        {estate.price} <br></br>
        {estate.address} <br></br>
        {estate.provider} <br></br>
        {estate.providerUrl} <br></br>  
      </div>;
    */}

    return <EstateDescription id={estate.id}
                              address={estate.address}
                              price={estate.price}
                              rooms={estate.rooms}
                              partner={"partner"}
                              like={false}
                              providerUrl={estate.providerUrl}
                              detailsUrl={estate.detailsUrl}
                              proximityScore={12}/>  
}

export default EstatePopup



/** WEBPACK FOOTER **
 ** ./app/components/EstatePopup.jsx
 **/